import React, { lazy } from 'react';
export function ExperienceSection() {
  return <section className="py-8 px-4" style={{
    backgroundColor: '#0d0d0d'
  }} data-id="element-70">
      <div className="max-w-2xl mx-auto" data-id="element-71">
        {/* Cinematic image placeholder */}
        <div className="w-full rounded-lg overflow-hidden mb-5 relative" style={{
        height: '280px',
        backgroundColor: '#1a1a1a'
      }} data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/aNk2baVqQL6U3hx8rUM6Sn/20260224_0953_Image_Generation_simple_compose_01kj7vcdhge74vdge9jjqeax3h.png" alt="Detectives revisando expedientes" className="w-full h-full object-cover" style={{
          filter: 'brightness(0.85)'
        }} loading="lazy" onError={e => {
          const target = e.target as HTMLImageElement;
          target.style.display = 'none';
        }} data-id="element-73" />
          {/* Overlay gradient */}
          <div className="absolute inset-0" style={{
          background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.2) 60%, transparent 100%)'
        }} data-id="element-74" />
          {/* Film grain overlay */}
          <div className="absolute inset-0 opacity-20 pointer-events-none" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='200' height='200' filter='url(%23n)' opacity='0.4'/%3E%3C/svg%3E")`
        }} data-id="element-75" />
          {/* Fallback content */}
          <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-76"></div>
        </div>

        {/* Text content */}
        <div className="text-center" data-id="element-77">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-4 leading-tight" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-78">
            Disfruta de una experiencia
            <br data-id="element-79" />
            <span style={{
            color: '#f0c040'
          }} data-id="element-80">
              fuera de la rutina
            </span>
          </h2>
          <p className="text-gray-400 text-base leading-relaxed max-w-lg mx-auto" data-id="element-81">
            Atrévete, toma el rol de detective y vive una experiencia
            completamente diferente. Momentos de suspenso y diversión para salir
            de la rutina con quienes más quieres.
          </p>

          {/* Feature pills */}
          <div className="flex flex-wrap justify-center gap-3 mt-6" data-id="element-82">
            {['🕵️ Rol de detective', '🔦 Pistas reales', '🤝 Trabajo en equipo', '🎭 Suspenso garantizado'].map(tag => <span key={tag} className="px-3 py-1.5 rounded-full text-xs text-gray-300" style={{
            backgroundColor: '#1a1a1a',
            border: '1px solid #333'
          }} data-id="element-83">
                {tag}
              </span>)}
          </div>
        </div>
      </div>
    </section>;
}